/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_Bulk_ReviewInputs */

const en_recipes_bulk_review = /** @type {(inputs: Recipes_Bulk_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewed`)
};

const de_recipes_bulk_review = /** @type {(inputs: Recipes_Bulk_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geprüft`)
};

/**
* | output |
* | --- |
* | "Reviewed" |
*
* @param {Recipes_Bulk_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_bulk_review = /** @type {((inputs?: Recipes_Bulk_ReviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Bulk_ReviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_bulk_review(inputs)
	return en_recipes_bulk_review(inputs)
});